import React from 'react';
import { useLocation } from 'react-router-dom';
import DeactivatedAccountScreen from '@/components/auth/DeactivatedAccountScreen';

const DeactivatedPage = () => {
  const location = useLocation();
  const { deactivatedAt, deactivationReason } = location.state || {};

  return (
    <DeactivatedAccountScreen
      deactivatedAt={deactivatedAt}
      deactivationReason={deactivationReason}
    />
  );
};

export default DeactivatedPage;